/* tslint:disable */
/* eslint-disable */
/**
 * Web App core API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum TopUpChartGroupBy {
    TOTAL = 'TOTAL',
    LAUNDRY_USER = 'LAUNDRY_USER',
    TOPUP_TYPE = 'TOPUP_TYPE'
}


export function TopUpChartGroupByFromJSON(json: any): TopUpChartGroupBy {
    return TopUpChartGroupByFromJSONTyped(json, false);
}

export function TopUpChartGroupByFromJSONTyped(json: any, ignoreDiscriminator: boolean): TopUpChartGroupBy {
    return json as TopUpChartGroupBy;
}

export function TopUpChartGroupByToJSON(value?: TopUpChartGroupBy | null): any {
    return value as any;
}

